var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F38E74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7558 23.712C14.5629 23.8964 14.3013 24 14.0285 24C13.7558 24 13.4941 23.8964 13.3013 23.712C13.1084 23.5276 13 23.2775 13 23.0168C13 22.756 13.1084 22.5059 13.3013 22.3215L16.7275 19.0473L16.7347 19.0404C17.0146 18.7783 17.3909 18.6315 17.7827 18.6315C18.1745 18.6315 18.5508 18.7783 18.8307 19.0404L18.8379 19.0473L20.5865 20.7188L22.9991 18.2798L21.93 17.2578C21.8224 17.1548 21.749 17.0235 21.7193 16.8806C21.6897 16.7377 21.7049 16.5896 21.7632 16.4551C21.8215 16.3205 21.9202 16.2054 22.0469 16.1244C22.1736 16.0434 22.3225 16.0001 22.4749 16H26.229C26.4335 16 26.6296 16.0776 26.7742 16.2159C26.9188 16.3541 27 16.5415 27 16.737V20.3257C26.9999 20.4714 26.9546 20.6138 26.8699 20.7348C26.7851 20.8559 26.6648 20.9503 26.524 21.006C26.3832 21.0617 26.2283 21.0763 26.0788 21.048C25.9293 21.0196 25.792 20.9495 25.6842 20.8465L24.4537 19.6693L21.6741 22.4807C21.5367 22.6162 21.3727 22.7245 21.1915 22.7992C21.0102 22.8739 20.8153 22.9136 20.618 22.9161C20.4206 22.9186 20.2247 22.8837 20.0414 22.8136C19.8582 22.7434 19.6913 22.6393 19.5503 22.5073L19.5431 22.5004L17.7822 20.818L14.7558 23.712Z",
    fill: "#F38E74"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon2);
export default __webpack_public_path__ + "static/media/card-icon2.77503e080462d1ae40b72fa21fd22d73.svg";
export { ForwardRef as ReactComponent };